import React, { useEffect, useState } from 'react'
import { Box, styled } from '@mui/system'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import MuiPhoneNumber from 'material-ui-phone-number'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer } from 'react-toastify'
import { useSearchParams } from 'react-router-dom'
import { Apis } from 'app/Apis/Apis'
import Alert from '@mui/material/Alert'
import validator from 'validator'
import { useNavigate } from 'react-router-dom'
const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const EditDoctor = () => {
    const [message, setMessage] = useState()
    const [doctordata, setDoctordata] = useState()
    const [alldata, setAllData] = useState({
        name: '',
        username: '',
        email: '',
        qualification: '',
        address: '',
    })
    const [phoneNum, setPhoneNum] = useState('')
    const [searchParams] = useSearchParams()
    const [emailErr, setEmailErr] = useState()
    const [imgdata, setImgdata] = useState()
    const imageUrl = imgdata?.name ? URL.createObjectURL(imgdata) : imgdata
    const roleId = searchParams.get('_id')
    const navigate = useNavigate()
    const singleDoctor = async () => {
        await axios
            .get(`${Apis.getSingleDoctor}/${roleId}`)
            .then((res) => {
                setDoctordata(res?.data?.data)
            })
            .catch((err) => {
                console.log('Errr in get edit doctor===========', err)
            })
    }
    const setState = () => {
        setAllData({
            name: doctordata?.name,
            username: doctordata?.username,
            email: doctordata?.email,
            qualification: doctordata?.qualification,
            address: doctordata?.address,
        })
        setImgdata(doctordata?.image)
        setPhoneNum(doctordata?.mobilenumber)
    }
    useEffect(() => {
        singleDoctor()
    }, [])

    useEffect(() => {
        setState()
    }, [doctordata])

    const handleChange = (e) => {
        setAllData({
            ...alldata,
            [e?.target?.name]: e.target.value,
        })
    }

    const imgHandleChange = (e) => {
        setImgdata(e.target.files[0])
    }

    const validateEmail = (value) => {
        if (validator.isEmail(value)) {
            setEmailErr(true)
        } else {
            setEmailErr('Contains invalid characters!')
        }
    }

    useEffect(() => {
        validateEmail(alldata?.email || '')
    }, [alldata?.email])
    const handleSubmit = () => {
        var formdata = new FormData()
        formdata.append('name', alldata.name)
        formdata.append('username', alldata.username)
        formdata.append('qualification', alldata.qualification)
        formdata.append('email', alldata.email)
        formdata.append('address', alldata.address)
        formdata.append('mobilenumber', phoneNum)
        formdata.append('_id', roleId)
        formdata.append('image', imgdata)
        let config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
        }

        if (
            !alldata.name ||
            !alldata.username ||
            !alldata.qualification ||
            !alldata.email ||
            !alldata.address ||
            !phoneNum
        ) {
            if (!alldata.name) {
                setMessage('Name is required !')
            } else {
                if (!alldata.username) {
                    setMessage('Username is required !')
                } else {
                    if (!alldata.email || emailErr != true) {
                        !alldata.email
                            ? setMessage('Email is required !')
                            : setMessage('Add valid email!')
                    } else {
                        if (!phoneNum) {
                            setMessage('Phone number is required !')
                        } else {
                            if (!alldata.qualification) {
                                setMessage(
                                    'Qualification details is required !'
                                )
                            } else {
                                if (!alldata.address) {
                                    setMessage('Address is required !')
                                }
                            }
                        }
                    }
                }
            }
        } else {
            axios
                .put(`${Apis.editDoctor}`, formdata, config)
                .then((res) => {
                    setMessage([
                        res?.data?.message || 'Doctor updated successfully',
                        res?.data?.code,
                    ])
                    setTimeout(() => {
                        navigate('/dashboard/doctorlist')
                    }, 2000)
                })
                .catch((err) => {
                    console.log('Error in EditDoctor', err)
                    setMessage(err?.response?.data?.message)
                })
        }
    }

    return (
        <Container>
            {message ? (
                <Alert
                    severity={message[1] === 200 ? 'success' : 'error'}
                    sx={{ position: 'fixed', width: '80%' }}
                >
                    {message.length === 2 ? message[0] : message}
                </Alert>
            ) : (
                ''
            )}
            <Link to={'/dashboard/doctorlist'}>
                <Box sx={{ padding: '15px 0px' }}>
                    <ArrowBackIcon />
                </Box>
            </Link>

            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    marginBottom: 5,
                    fontWeight: 500,
                    fontSize: 20,
                }}
            >
                Edit doctor details
            </Box>
            <Box
                sx={{
                    borderBottom: 'solid',
                    borderColor: 'grey.200',
                    width: '110%',
                }}
            >
                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Name</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            label="Name"
                            type="text"
                            name="name"
                            value={alldata?.name}
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Username</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',

                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            label="Username"
                            type="text"
                            name="username"
                            value={alldata?.username}
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                        />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Email</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Email"
                            type="email"
                            name="email"
                            value={alldata?.email}
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Phone number</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <MuiPhoneNumber
                            label="Phone Number"
                            defaultCountry={'us'}
                            variant="outlined"
                            name="phone"
                            value={phoneNum}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            onChange={(e) => {
                                setPhoneNum(e)
                            }}
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Qualification</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Qualification"
                            type="text"
                            name="qualification"
                            value={alldata?.qualification}
                            onChange={handleChange}
                            sx={{ paddingBottom: 1, width: '30vh' }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Address</Box>{' '}
                    <Box
                        sx={{
                            width: '70%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                        }}
                    >
                        {' '}
                        <TextField
                            id="outlined-password-input"
                            label="Address"
                            multiline
                            name="address"
                            value={alldata?.address}
                            onChange={handleChange}
                            type="text"
                            sx={{ paddingBottom: 1, width: '50vw' }}
                            autoComplete="current-password"
                        />
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', paddingBottom: 1 }}>
                    <Box sx={{ width: '30%' }}>Profile image</Box>{' '}
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'start',
                            alignItems: 'center',
                            width: '50%',
                        }}
                    >
                        <img
                            src={imageUrl || imgdata}
                            alt=""
                            style={{
                                width: '75px',
                                height: '75px',
                                position: 'relative',
                                borderRadius: '50px',
                                left: '2%',
                            }}
                        />
                        <input
                            type="file"
                            onChange={imgHandleChange}
                            id="avatarUpload"
                            style={{ display: 'none' }}
                        />

                        <Box sx={{ marginLeft: 5 }}>
                            <Button variant="contained">
                                <label htmlFor="avatarUpload">
                                    Upload photo
                                </label>
                            </Button>{' '}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Button
                variant="contained"
                sx={{ marginTop: 3 }}
                onClick={handleSubmit}
            >
                Submit
            </Button>
            <ToastContainer />
        </Container>
    )
}

export default EditDoctor
